// extracted by mini-css-extract-plugin
module.exports = {"animationF":"animationF_animationF__17mOE"};